import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getVendorFormBuilderHandlerSaga(action) {
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.vendorFormList(action.payload),
		);
		yield put({
			type: types.GET_VENDORFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_VENDORFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getVendorFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_VENDORFORMLIST_START,
		getVendorFormBuilderHandlerSaga,
	);
}

//get/id

//create
